import React from 'react';
import styled, { css } from 'styled-components';
import { Box, Icongraphy } from '@design-system/pc';

interface DateTimeBtnProps {
  onClick: () => void;
  value: string;
}

const DateTimeBtn = ({ onClick, value, ...props }: DateTimeBtnProps) => {
  return (
    <Box
      onClick={onClick}
      position="relative"
      width="100%"
      height="48px"
      borderRadius="2px"
      border="1px solid"
      borderColor="color_chip.gray.200"
      {...props}
    >
      <InputBox
        readOnly
        value={value}
        placeholder="날짜와 시간을 선택해 주세요."
      ></InputBox>
      <Box position="absolute" top="16px" right="12px">
        <Icongraphy variant="ic_arrow_down_bold" size={14} resize />
      </Box>
    </Box>
  );
};

export default DateTimeBtn;

const InputBox = styled.input`
  ${({ theme }) => css`
    width: 100%;
    border: none;
    height: 100%;
    padding: 14px 44px 14px 16px;
    box-sizing: border-box;
    cursor: pointer;
    ::placeholder {
      color: ${theme.colors.color_chip.gray[500]};
    }
  `}
`;
